import { useTheme } from "../ThemeProvider";

import { parseEuroAmount, formatEuroAmount } from "../../utils/moneyParse";

import usePermiso from "../../hooks/usePermiso";

import { esOperacionAlquiler } from "../../utils/esOperacionAlquiler";

import { usePropiedadUi } from "../../hooks/usePropiedadUi";



function CampoEntero({ label, name, unidad, form, cambiar, cambiarDirecto, inputStyle, obsStyle, labelStyle, disabled = false, tv = (x) => x }) {

  const valorInicial = form[name] ? Math.round(parseFloat(form[name])).toLocaleString("es-ES") : "";

  return (

    <div style={{ minWidth: 150 }}>

      <label style={labelStyle}>{tv(label)}</label>

      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>

        <input type="text" inputMode="numeric" name={name}

          defaultValue={valorInicial}

          disabled={disabled}

          onFocus={e => { const raw = parseInt(e.target.value.replace(/\./g, ""), 10); e.target.value = isNaN(raw) ? "" : raw; }}

          onBlur={e => { const raw = parseInt(e.target.value.replace(/\./g, ""), 10); cambiarDirecto(name, isNaN(raw) ? "" : raw); e.target.value = isNaN(raw) ? "" : raw.toLocaleString("es-ES"); }}

          style={{ ...inputStyle, flex: 1, opacity: disabled ? 0.6 : 1 }} />

        <span style={{ fontSize: 12, color: "#64748b", fontWeight: 600, whiteSpace: "nowrap" }}>{unidad}</span>

      </div>

      <input type="text" name={name + "_obs"} value={form[name + "_obs"] || ""} onChange={cambiar} disabled={disabled}

        placeholder={tv("Observaciones")} style={{ ...obsStyle, opacity: disabled ? 0.6 : 1 }} />

    </div>

  );

}



function CampoEuroDecimales({ label, name, unidad, form, cambiar, cambiarDirecto, inputStyle, obsStyle, labelStyle, disabled = false, tv = (x) => x }) {

  const raw = form[name];

  const valorInicial = raw != null && raw !== "" && Number.isFinite(parseEuroAmount(raw))

    ? formatEuroAmount(raw)

    : (raw != null && raw !== "" ? String(raw) : "");



  return (

    <div style={{ minWidth: 150 }}>

      <label style={labelStyle}>{tv(label)}</label>

      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>

        <input

          type="text"

          inputMode="decimal"

          name={name}

          defaultValue={valorInicial}

          disabled={disabled}

          onBlur={(e) => {

            const n = parseEuroAmount(e.target.value);

            cambiarDirecto(name, Number.isFinite(n) ? n : "");

            e.target.value = Number.isFinite(n) ? formatEuroAmount(n) : "";

          }}

          style={{ ...inputStyle, flex: 1, opacity: disabled ? 0.6 : 1 }}

        />

        <span style={{ fontSize: 12, color: "#64748b", fontWeight: 600, whiteSpace: "nowrap" }}>{unidad}</span>

      </div>

      <input type="text" name={name + "_obs"} value={form[name + "_obs"] || ""} onChange={cambiar} disabled={disabled}

        placeholder={tv("Observaciones")} style={{ ...obsStyle, opacity: disabled ? 0.6 : 1 }} />

    </div>

  );

}



export default function SeccionEconomicos(props) {

  const { form, cambiar, cambiarDirecto } = props;

  const { tv } = usePropiedadUi(props);

  const { theme } = useTheme();

  const c = theme.colors;

  const isDark = theme.name === "dark";

  const { puede } = usePermiso();

  const puedeVerGastosComunidad = puede("gastos_comunidad", "ver");

  const puedeModificarGastosComunidad = puede("gastos_comunidad", "modificar");

  const puedeVerIbi = puede("ibi", "ver");

  const puedeModificarIbi = puede("ibi", "modificar");

  const puedeVerHipoteca = puede("hipoteca", "ver");

  const puedeModificarHipoteca = puede("hipoteca", "modificar");

  const puedeVerBasuras = puede("basuras", "ver");

  const puedeModificarBasuras = puede("basuras", "modificar");

  const puedeVerValoracion = puede("valoracion", "ver");

  const puedeModificarValoracion = puede("valoracion", "modificar");

  const esAlquiler = esOperacionAlquiler(form.operacion);



  const labelStyle = {

    fontSize: 11, fontWeight: 600, color: c.textMuted,

    textTransform: "uppercase", letterSpacing: "0.04em",

    marginBottom: 6, display: "block",

  };

  const inputStyle = {

    padding: "8px 12px", border: `1px solid ${c.chipBorder}`,

    borderRadius: 8, fontSize: 13, color: c.textPrimary,

    background: isDark ? '#0a0e16' : '#dceeff', outline: "none",

    boxShadow: isDark ? 'inset 0 3px 6px rgba(0,0,0,0.5), inset 0 1px 3px rgba(0,0,0,0.3)' : 'inset 0 3px 6px rgba(100,140,200,0.18), inset 0 1px 3px rgba(80,120,180,0.13)',

  };

  const obsStyle = {

    ...inputStyle, fontSize: 11, padding: "5px 10px",

    marginTop: 4, color: c.textSecondary, width: "100%",

  };



  const Toggle = ({ name, label, disabled = false }) => {

    const checked = form[name] || false;

    return (

      <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: disabled ? "not-allowed" : "pointer", userSelect: "none", opacity: disabled ? 0.6 : 1 }}

        title={disabled ? "No tienes permiso para modificar este dato" : undefined}

      >

        <div

          onClick={() => { if (!disabled) cambiarDirecto(name, !checked); }}

          style={{

            width: 34, height: 20, borderRadius: 10,

            background: checked ? c.accentBlue : c.border,

            position: "relative", transition: "background 0.2s",

            flexShrink: 0, cursor: disabled ? "not-allowed" : "pointer",

          }}

        >

          <div style={{

            width: 14, height: 14, borderRadius: "50%", background: "#fff",

            position: "absolute", top: 3, left: checked ? 17 : 3,

            transition: "left 0.2s", boxShadow: "0 1px 3px rgba(0,0,0,0.2)",

          }} />

        </div>

        <span style={{ fontSize: 13, color: c.textPrimary }}>{tv(label)}</span>

      </label>

    );

  };



  return (

    <div style={{ display: "flex", flexWrap: "wrap", gap: 20, alignItems: "flex-start" }}>

      {puedeVerGastosComunidad && <CampoEntero label="Gastos Comunidad" name="gastos_comunidad" unidad="€/mes" form={form} cambiar={cambiar} cambiarDirecto={cambiarDirecto} inputStyle={inputStyle} obsStyle={obsStyle} labelStyle={labelStyle} disabled={!puedeModificarGastosComunidad} tv={tv} />}

      {puedeVerBasuras && <CampoEuroDecimales label="Basuras" name="basuras" unidad="€/año" form={form} cambiar={cambiar} cambiarDirecto={cambiarDirecto} inputStyle={inputStyle} obsStyle={obsStyle} labelStyle={labelStyle} disabled={!puedeModificarBasuras} tv={tv} />}

      {puedeVerIbi && <CampoEuroDecimales label="IBI" name="ibi" unidad="€/año" form={form} cambiar={cambiar} cambiarDirecto={cambiarDirecto} inputStyle={inputStyle} obsStyle={obsStyle} labelStyle={labelStyle} disabled={!puedeModificarIbi} tv={tv} />}

      {!esAlquiler && puedeVerValoracion && (

        <CampoEntero label="Valoración" name="valoracion" unidad="€" form={form} cambiar={cambiar} cambiarDirecto={cambiarDirecto} inputStyle={inputStyle} obsStyle={obsStyle} labelStyle={labelStyle} disabled={!puedeModificarValoracion} tv={tv} />

      )}



      {!esAlquiler && puedeVerHipoteca && (

      <div style={{ minWidth: 150 }}>

        <label style={labelStyle}>{tv("Hipoteca")}</label>

        <div style={{ height: 38, display: "flex", alignItems: "center" }}>

          <Toggle name="hipoteca" label="Tiene hipoteca" disabled={!puedeModificarHipoteca} />

        </div>

        <input type="text" name="hipoteca_obs" value={form.hipoteca_obs || ""} onChange={cambiar} disabled={!puedeModificarHipoteca}

          placeholder={tv("Observaciones")} style={{ ...obsStyle, opacity: puedeModificarHipoteca ? 1 : 0.6 }} />

      </div>

      )}

    </div>

  );

}

